import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step4 } from '../../../../shared/models/component-messages/mapaAT/step4';
import { TypeAdresseCompleteMorale } from '../models/TypeAdresseCompleteMorale';

@Component({
  selector: 'app-type-adresse-complete-morale',
  templateUrl: './type-adresse-complete-morale.component.html'
})
export class TypeAdresseCompleteMoraleComponent implements OnInit {

  @Input() uid = '';
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;
  @Input() titulaire : TypeAdresseCompleteMorale;
  @Input() errorMessagePersonneMoral: string;
  @Input() required: string;

  public step4 = new Step4();

  constructor() { }

  public ngOnInit() { }

  getUid() {
    return this.uid + '_SepSep_TypeAdresseCompleteMorale';
  }
}
